<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer082">
<p class="structure-img" id="calibre_pb_15"><img alt="" class="_idgenobjectattribute2" src="OEBPS/image/bird-01.png"/></p>
<p class="basic-paragraph"><span class="charoverride10">To You,</span></p>
<p class="basic-paragraph"><span class="charoverride10">My Fellow Human.</span></p>
<div class="calibre1" id="calibre_pb_16"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GladtoBeHuman_split_007.vue?ec0cf374